
import { Component, Prop, PropSync, Vue } from 'nuxt-property-decorator'
import { AgeGroup, ExtendedProviderModel } from '~/core/offer.types'

@Component
export default class ReviewsFilter extends Vue {
  @Prop({ required: true })
  readonly provider!: ExtendedProviderModel

  @PropSync('city', { required: true })
  readonly syncedCity!: string

  @PropSync('ageGroup', { required: true })
  readonly syncedAgeGroup!: number

  @PropSync('rating', { required: true })
  readonly syncedRating!: number

  get ratingOptions () {
    return [
      {
        label: this.$t('ratings.filter.allRatings'),
        value: 0,
      },
      ...[1, 2, 3, 4, 5].map((idx) => {
        return {
          label: this.$t('ratings.filter.stars', { amount: idx }),
          value: idx,
        }
      }),
    ]
  }

  get ageGroupOptions () {
    return [
      { label: this.$t('ratings.filter.allAgeGroups'), value: 0 },

      ...Object.keys(AgeGroup).map((key) => {
        const ageGroup = key as keyof typeof AgeGroup
        return {
          label: AgeGroup[ageGroup],
          value: key,
        }
      }),

    ]
  }
}
